<template>
  <div>
   <div class="grid-row">
      <div class=" titulo-grid">
        Status da Tarefa
      </div>
    </div>

    <div class="grid-row">
      <div class=" titulo">
        Status
      </div>
      <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.finalized_at == null">
          {{ dadosFichaTecnica.pco_tarefa.status_atual.ctrl_status.status.toUpperCase() }}
        </span>
        <span v-else>
          Concluída
        </span>
      </div>
      <div class=" titulo">
        Aging Status
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.status_atual.aging_dias_formatado }}
      </div>
    </div>
    <div class="grid-row">
      <div class="">
      </div>
      <div class="">
      </div>
      <div class=" titulo">
        Aging Status Disponível
      </div>
      <div class="">
        {{ 
            (dadosFichaTecnica.pco_tarefa.status_atual.pco_macro_status) ? 
            dadosFichaTecnica.pco_tarefa.status_atual.pco_macro_status.aging_dias_formatado:''
        }}
      </div>
    </div>


    <div class="grid-row" v-if="dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao">
      <div class=" titulo-grid">
        Tarefa de Interrupção
      </div>
    </div>

    <div class="grid-row" v-if="dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao">
      <div class=" titulo">
        Usuário cadastro
      </div>
      <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao.user_cadastro">
          {{ dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao.user_cadastro.name.toUpperCase() }}
        </span>
        <span v-else>-</span>
      </div>
      <div class=" titulo">
        Usuário tratamento
      </div>
      <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao.user_tratamento">
          {{ dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao.user_tratamento.name.toUpperCase() }}
        </span>
        <span v-else>-</span>
      </div>
    </div>

    <div class="grid-row" v-if="dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao">
      <div class=" titulo">
        Tarefa de interrupção
      </div>
      <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao.ctrl_tarefa">
          {{ dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao.ctrl_tarefa.tarefa.toUpperCase() }}
        </span>
        <span v-else>-</span>
      </div>
      <div class=" titulo">
        Pendência
      </div>
      <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao.ctrl_tarefa.pendencia_star21">
          {{ dadosFichaTecnica.pco_tarefa.pco_tarefa_interrupcao.ctrl_tarefa.pendencia_star21.pendencia.toUpperCase() }}
        </span>
        <span v-else>-</span>
      </div>
    </div>
 </div>  
</template>

<script>

export default {
  name: "StatusTarefaComponent",
  props: {
    dadosFichaTecnica: {
      type: Array,
      required: true
    }
  },
  
}
</script>